import { Component, OnInit, ComponentFactoryResolver, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { DocumentRequestService } from "src/app/v2-node-api/services/document-request.service";
import { UploadDocumentsComponent } from "../upload-documents/upload-documents.component";
import { UserService } from "src/shared/services/user/user.service";
import { DialogEditRequestComponent } from "../dialog-edit-request/dialog-edit-request.component";
import { SendMessageComponent } from "../send-message/send-message.component";
import { DilogSeeDocumentComponent } from "../dilog-see-document/dilog-see-document.component";

@Component({
  selector: "see-requests",
  templateUrl: "./see-requests.component.html",
  styleUrls: ["./see-requests.component.scss"]
})
export class SeeRequestsComponent implements OnInit {
  @Input() highlightTitle = false;
  public requests: any[] = [];
  public createdRequest: any[] = [];
  public receivedRequest: any[] = [];
  public validtedRequest: any[] = [];
  public requestId = "";
  public selectedIndex = 0;
  constructor(
    protected documentRequestService: DocumentRequestService,
    private activeRoute: ActivatedRoute,
    protected router: Router,
    private dialog: MatDialog,
    protected userService: UserService
  ) {}

  ngOnInit(): void {
    this.requests = [];
    this.createdRequest = [];
    this.receivedRequest = [];

    this.initialize();
  }

  initialize() {
    const params = this.activeRoute.snapshot.url;
   
    if (params.length) {
      this.requestId = params[0].path;
    }
    this.documentRequestService
      .queryDocumentRequests({
        receiver: this.userService.user.id,
        status: "pending"
      })
      .subscribe(res => {
        this.receivedRequest = res;

        this.receivedRequest.forEach(element => {
          element.isMine=false;
          if (element._id == this.requestId) {
            element.isOpen = true;
            this.selectedIndex = 1;
          }
        });

        this.activeRoute.queryParams.subscribe(queryParams => {
         
          if (queryParams.id) {
            const index = this.receivedRequest
              .map(req => req._id)
              .indexOf(queryParams.id);
            if (~index) {
              //this.openRequest(this.receivedRequest[index], index);
            }
          }
        });
      });

    this.documentRequestService.getCreatedDocumentRequests().subscribe(res => {
      this.createdRequest = res.map(r => {
        r.isOpen = false;
        return r;
      });

      this.createdRequest.forEach(element => {
        if (element._id == this.requestId) {
          element.isOpen = true;
          this.selectedIndex = 0;
          this.selectedIndex = 2;
        }
      });
    });

   

      
  }

  edit(id, index) {}

  delete({ id, index }) {
    this.documentRequestService.delete(id).subscribe(res => {
      this.createdRequest.splice(index, 1);
    });
    this.initialize();
  }

  openRequest({ request, i }: { request: any; i: number }) {
    const dialogRef = this.dialog.open(UploadDocumentsComponent, {
      width: "70%",
      height: "60%",
      data: {
        request
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      // this.router.navigate([]);

      if (res) {
         this.initialize();
        //this.validtedRequest.push(this.receivedRequest[i]);
     //   this.receivedRequest.splice(i, 1);
      }
    });
  }

  onOpenRequestValidated({ request, i }: { request: any; i: number }) {
    const dialogRef = this.dialog.open(UploadDocumentsComponent, {
      width: "76%",
      height: "75%",
      data: {
        request,
        seeAsSenderValidating: true
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      // this.router.navigate([]);
 
     this.initialize();
    });
  }

  editRequest({ request }) {
    const dialogRef = this.dialog.open(DialogEditRequestComponent, {
      width: "67%",
      height: "64%",
      data: {
        oldRequest: request
      }
    });
    dialogRef.afterClosed().subscribe((res)=>{
      this.initialize();
    })
  }

  sendMessage({request}){
    
    const dialogRef = this.dialog.open(SendMessageComponent, {
      width: "10%",
      height: "10%",
      data: {
        oldRequest: request
      }
    });
    dialogRef.afterClosed().subscribe((res)=>{
      this.initialize();
    })
  }

  seeDocument(doc){
  const dialogRef = this.dialog.open(DilogSeeDocumentComponent,{
    width: "50%",
    height: "70%",
    data: {
      document: doc.document,
      request:doc.request,
     
    }

  });

  dialogRef.afterClosed().subscribe((res)=>{
    this.initialize();
  })
  }
}
